<p-dialog
  [header]="isLoading ? 'Checking Voice Profile Usage' : (canDelete ? 'Delete Voice Profile' : 'Cannot Delete Voice Profile')"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '55vw' }"
  (onHide)="onCloseDialog()">

  <div *ngIf="isLoading">
    <p>Checking whether the selected voice profiles are attached to any devices...</p>
  </div>

  <div *ngIf="!isLoading && canDelete">
    <p>Do you want to delete the following?</p>
    <p-table
      [value]="vConfigs"
      responsiveLayout="scroll"
      styleClass="p-datatable-sm p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Voice Profile</th>
          <th>Org</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-vConfig>
        <tr>
          <td>{{ vConfig.name }}</td>
          <td>{{ vConfig.org?.name || 'No Org Assigned' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="!isLoading && !canDelete" class="delete-warning-box">
    <p class="delete-warning-title">
      The selected voice profile cannot be deleted because one or more devices are still attached.
    </p>

    <p class="delete-warning-text">
      Unassign the voice profile from those devices, then try again.
    </p>

    <div *ngFor="let group of attachedDevicesByProfile" class="p-mb-4">
      <div class="profile-org-header">
        <span><strong>Profile:</strong> {{ group.profileName }}</span>
        <span><strong>Org:</strong> {{ group.profileOrg || 'No Org Assigned' }}</span>
      </div>

      <p-table
        [value]="group.devices"
        responsiveLayout="scroll"
        styleClass="p-datatable-sm p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th>Device</th>
            <th>Serial</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-device>
          <tr>
            <td>{{ device.name || 'No Name Assigned' }}</td>
            <td>{{ device.serial || 'No Serial Assigned' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      *ngIf="!isLoading && canDelete"
      label="Cancel"
      styleClass="p-button-text"
      (onClick)="closeDialog()">
    </p-button>

    <p-button
      *ngIf="!isLoading && canDelete"
      icon="fas fa-trash"
      (onClick)="delete()"
      label="Delete"
      styleClass="p-button-danger">
    </p-button>

    <p-button
      *ngIf="!isLoading && !canDelete"
      label="OK"
      (onClick)="closeDialog()">
    </p-button>
  </ng-template>
</p-dialog>
